module.exports = __webpack_public_path__ + "img/gamepad.6b614187.svg";